import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import {MAPS_VENDORS, PANORAMAS_VENDORS} from '../../../consts';
import { MultiSelect } from '../../Controls';
import { sortByName } from '../../../utils/infrastructure';

class MapsControls extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      activeView: props.activeView,
      itemsInfrastructure: []
    };

    this.infrastructureHash = null;
    this.handlerShowDGis = this.handlerShowDGis.bind(this);
    this.handlerShowYandex = this.handlerShowYandex.bind(this);
    this.handlerShowGooglePanorama = this.handlerShowGooglePanorama.bind(this);
  }

  handlerShowDGis () {
    this.props.onChangeView(MAPS_VENDORS.dgis);
  }

  handlerShowYandex () {
    this.props.onChangeView(MAPS_VENDORS.yandex);
  }

  handlerShowGooglePanorama () {
    this.props.onChangeView(PANORAMAS_VENDORS.yandex);
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.activeView !== this.state.activeView) {
      this.setState({
        activeView: nextProps.activeView
      });
    }

    if (this.infrastructureHash !== nextProps.listInfrastructure.hashCode()) {
      this.makeItemsInfrastructure(nextProps.listInfrastructure);
    }
  }

  makeItemsInfrastructure (listInfrastructure) {
    const itemsInfrastructure = listInfrastructure.toArray()
      .map((item) => {
        return {
          id: item.get('id'),
          name: item.get('name') + ' (' + item.get('count') + ')',
          shortName: item.get('name')
        };
      })
      .sort(sortByName);

    this.setState({itemsInfrastructure});
    this.infrastructureHash = listInfrastructure.hashCode();
  }

  renderInfrastructureSelect () {
    if (this.props.disableInfrastructure || !this.state.itemsInfrastructure.length) {
      return null;
    }

    return (
      <div className='infrastructure'>
        <MultiSelect
          items={this.state.itemsInfrastructure}
          name='infrastructure-select'
          value={this.props.selectInfrastructure}
          staticButtonText='Инфраструктура'
          onUpdate={this.props.onChangeInfrastructure}
        />
      </div>
    );
  }

  render () {
    const view = this.state.activeView;
    return (
      <div className='maps-controls-wrp'>
        <div className='toogle-view'>
          <button className='btn btn-base btn-underline' disabled={view === MAPS_VENDORS.dgis} onClick={this.handlerShowDGis}>2ГИС</button>
          <button className='btn btn-base btn-underline' disabled={view === MAPS_VENDORS.yandex} onClick={this.handlerShowYandex}>ЯНДЕКС</button>

          { !this.props.disablePanorama && <button className='btn btn-base btn-underline' disabled={view === PANORAMAS_VENDORS.yandex} onClick={this.handlerShowGooglePanorama}>ПАНОРАМА 360</button>}
        </div>

        { this.renderInfrastructureSelect() }
      </div>
    );
  }
}

MapsControls.propTypes = {
  onChangeView: PropTypes.func.isRequired,
  activeView: PropTypes.string.isRequired,
  disablePanorama: PropTypes.bool,

  disableInfrastructure: PropTypes.bool,
  listInfrastructure: PropTypes.object,
  selectInfrastructure: PropTypes.string,
  onChangeInfrastructure: PropTypes.func.isRequired
};

MapsControls.defaultProps = {
  disablePanorama: false,
  listInfrastructure: new Map()
};

export default MapsControls;



// WEBPACK FOOTER //
// ./src/ui/Maps/Controls/MapsControls.jsx